import { combineReducers } from "redux";
import { configureStore } from "@reduxjs/toolkit";
import { createReduxHistoryContext } from "redux-first-history";
import { createBrowserHistory } from "history";

const {
  createReduxHistory,
  routerMiddleware,
  routerReducer
} = createReduxHistoryContext({ history: createBrowserHistory() });

const headerHeightReducer = (state = 0, action) => {
  switch (action.type) {
    case 'SET_HEADER_HEIGHT':
      return action.payload;
    default:
      return state;
  }
};

const productCategoriesReducer = (state = [], action) => {
  switch (action.type) {
    case 'SET_PRODUCT_CATEGORIES':
      return action.payload;
    default:
      return state;
  }
};

const languageReducer = (state = 'zh-Hant', action) => {
  switch (action.type) {
    case 'SET_LANGUAGE':
      return action.payload;
    default:
      return state;
  }
};

export const store = configureStore({
  reducer: combineReducers({
    router: routerReducer,
    headerHeight: headerHeightReducer,
    productCategories: productCategoriesReducer,
    language: languageReducer
  }),
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(routerMiddleware),
});

export const history = createReduxHistory(store);